import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

export const useInvoicePdf = () => {
  const { mutateAsync, ...queryResponse } = useMutation({
    mutationKey: ["invoice-pdf"],
    mutationFn: (invoiceId) => api.invoices.fetchInvoicePdf(invoiceId),
  });

  const previewInvoicePdf = async (invoiceId) => {
    const data = await mutateAsync(invoiceId);
    const blob = new Blob([data.data], { type: data.contentType });
    const objectUrl = URL.createObjectURL(blob);
    window.open(objectUrl, "_blank");
    // Revoked later rather than immediately, so the new tab has time to load it.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  };

  const downloadInvoicePdf = async (invoiceId) => {
    const data = await mutateAsync(invoiceId);
    const blob = new Blob([data.data], { type: data.contentType });
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = data.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(objectUrl);
  };

  const { fetchState } = useFetchStateHelper(queryResponse);

  return { previewInvoicePdf, downloadInvoicePdf, fetchState };
};

export const useLatestInvoiceId = (enabled) => {
  const queryResponse = useQuery({
    queryKey: ["latest-invoice"],
    queryFn: api.invoices.fetchLatestInvoice,
    enabled,
  });
  const { fetchState } = useFetchStateHelper(queryResponse);

  return { invoiceId: queryResponse.data?.id ?? null, fetchState };
};

export const useTaxNumberLookup = () => {
  const { mutateAsync, ...queryResponse } = useMutation({
    mutationKey: ["tax-number-lookup"],
    mutationFn: ({ taxNumber, signal }) =>
      api.invoices.lookupTaxNumber(taxNumber, signal),
    retry: false,
  });
  const { fetchState } = useFetchStateHelper(queryResponse);

  return { lookupTaxNumber: mutateAsync, fetchState };
};
